import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { LegalModule } from './legal/legal.module';
import { SharedModule } from './shared/shared.module';
import { ANALYTICS_ADAPTER, NoopAnalyticsAdapter } from './services/analytics.service';
import { JsonInterceptor } from './json.interceptor';

@NgModule({
  declarations: [AppComponent],
  imports: [BrowserModule, HttpClientModule, FormsModule, IonicModule.forRoot(), SharedModule, LegalModule, AppRoutingModule],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: ANALYTICS_ADAPTER, useClass: NoopAnalyticsAdapter },
    { provide: HTTP_INTERCEPTORS, useClass: JsonInterceptor, multi: true},
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
